<template>
  <v-layout wrap class="spectralis-comparison-body oct-browser-body">
    <v-flex xs12>
      <oct-comparison-toolbar />
    </v-flex>
    <v-flex xs12 class="oct-comparison-view">
      <spectralis-comparison-view
        name="compare"
        :context="compare"
        :exams="compareExams"
        :groups="compareGroups"/>
    </v-flex>
    <v-flex xs12 class="oct-comparison-view">
      <spectralis-comparison-view
        name="baseline"
        :context="baseline"
        :exams="baselineExams"
        :groups="baselineGroups"/>
    </v-flex>
  </v-layout>
</template>

<script>
import octComparisonToolbar from "./OCTComparisonToolbar";
import spectralisComparisonView from "./SpectralisComparisonView";
import { mapGetters } from "vuex";
export default {
  name: "spectralisComparisonBody",
  components: { octComparisonToolbar, spectralisComparisonView },
  computed: {
    ...mapGetters([
      "baseline",
      "baselineExams",
      "baselineGroups",
      "compare",
      "compareExams",
      "compareGroups"])
  }
};
</script>